module.exports = __webpack_public_path__ + "img/18.38ad6706.jpg";